"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 0 ", ";\n  grid-template-columns: repeat(auto-fill, minmax(", "px, 1fr));\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var common_1 = require("../common");

var theme_1 = require("../theme");

exports.Grid = (0, common_1.styledContainer)(_templateObject(), function (props) {
  return (0, theme_1.getSize)(props.theme, props.gap || '@size-l');
}, function (props) {
  return props.columnSize || 360;
});